import * as types from '../types/pictureBusinessProfile';

const initialState = {
  loading: false,
  logoUrl: null,
  error: null,
};

const pictureBusinessProfileReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_PICTURE_PROFILE_BUSINESS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_PICTURE_PROFILE_BUSINESS_SUCCESS:
      return {
        ...state,
        loading: false,
        logoUrl: action.payload,
      };
    case types.FETCH_PICTURE_PROFILE_BUSINESS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default pictureBusinessProfileReducer;
